import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { useFormik, FormikProvider, Field } from "formik";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import { Form, Table, Modal } from "react-bootstrap";

import ShowAlert from "../../alert";
import { generatePDF, ModuleHeader, NumberValidation, showNotification } from "../../utils/commonFunctions";
import { MdOutlinePictureAsPdf, MdPersonAddAlt1 } from "react-icons/md";
import { store } from "../../../App";
import { MdPersonRemoveAlt1 } from "react-icons/md";
import { FaUserEdit } from "react-icons/fa";
import Swal from "sweetalert2/dist/sweetalert2.js";

function HeadsMaster() {
  const history = useHistory();
  const [tableData, settabledata] = useState();
  const [classifyData, setClassifyData] = useState();
  const [popup, setPopup] = useState(false);
  const [editpopup, seteditPopup] = useState(false);

  const formik = useFormik({
    initialValues: {
      headid: "",
      headname: "",
      payments: "",
      receipts: "",
      classification: "",
      addclassification: "",
      editheadid: "",
      editheadname: "",
      editpayments: "",
      editreceipts: "",
      editclassification: ""
    },
    onSubmit: () => {
      alert("submit3", formik.values);
    }
  });

  const submitaddAction = async () => {
    const { headid, headname, addclassification, payments, receipts } = formik.values;

    if (!headid || !headname || !addclassification) {
      let missingFields = [];

      if (!headid) missingFields.push("Head ID");
      if (!headname) missingFields.push("Head Name");
      if (!addclassification) missingFields.push("Classification");

      ShowAlert(`Please fill the required fields: ${missingFields.join(", ")}`, "warning");
      return; // stop further execution
    }

    store.dispatch({ type: "SHOW_SPINNER" });

    try {
      const param1 = {
        action: "add",
        headid,
        headname,
        payments: payments ? payments : false,
        receipts: receipts ? receipts : false,
        classification: addclassification,
      };

      const res = await HousingService.HeadMasterActions(param1);

      if (res?.data?.SCODE === "01") {
        ShowAlert(res?.data?.SDESC, "success");
        setPopup(false);
        setTimeout(() => {
          history.go(0);
        }, 2000);
      } else {
        ShowAlert(res?.data?.SDESC, "error");
      }
    } catch (error) {
      ShowAlert(error?.message, "error");
    } finally {
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };




  const addAction = () => {
    setPopup(true);
  };
  const editAction = (headid, headname, payments, receipts, classification) => {
    formik.setFieldValue("editheadid", headid);
    formik.setFieldValue("editheadname", headname);
    formik.setFieldValue("editpayments", payments);
    formik.setFieldValue("editreceipts", receipts);
    formik.setFieldValue("editclassification", classification);

    seteditPopup(true);
  };

  const deleteAction = (headid, headname, payments, receipts) => {
    Swal.fire({
      text: "Are You Sure Want to Delete Head?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        store.dispatch({ type: "SHOW_SPINNER" });
        let param3 = { action: "delete", headid: headid, headname: headname, payments: payments, receipts: receipts };
        HousingService.HeadMasterActions(param3).then((response) => {
          if (response?.data?.SCODE === "01") {
            showNotification("success", "Head Id Deleted successfully");
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        }).catch((error) => {
          ShowAlert("Some error occurred", "error");
          console.log(error);
        }).finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
        });;


      }
    });


  };
  const submitEditAction = () => {
    if (!formik.values.editheadid || !formik.values.editheadname || !formik.values.editclassification) {
      let missingFieldsEdit = [];

      if (!formik.values.editheadid) missingFieldsEdit.push("Head ID");
      if (!formik.values.editheadname) missingFieldsEdit.push("Head Name");
      if (!formik.values.editclassification) missingFieldsEdit.push("Classification");

      ShowAlert(`Please fill the required fields: ${missingFieldsEdit.join(", ")}`, "warning");
      return; // stop further execution
    }

    store.dispatch({ type: "SHOW_SPINNER" });
    let param2 = { action: "edit", headid: formik.values.editheadid, headname: formik.values.editheadname, payments: formik.values.editpayments, receipts: formik.values.editreceipts, classification: formik.values.editclassification };
    console.log("param2", param2)
    HousingService.HeadMasterActions(param2).then((res) => {
      if (res?.data?.SCODE === "01") {
        ShowAlert(res?.data?.SDESC, "success");
      }
    }).catch((error) => {
      ShowAlert("Some error occured", "error");
    }).finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
      setPopup(false);
      setTimeout(() => {
        history.go(0);
      }, 2000);
    })
  };

  React.useEffect(() => {
    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.classificationDropdown().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (
              <option key={i} value={item.classification_id}>
                {item.classification_name}
              </option>
            );
          }
        });
        setClassifyData(options);
      }
    });
    HousingService.HeadsDetails().then((res) => {
      settabledata(res.data);
    }).catch((error) => {
      console.log(error)
    }).finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  }, []);


  return (
    <>
      <NavigationServicesHeader />
      <ModuleHeader title="Head Master" />
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
        <FormikProvider value={formik}>
          <Form>
            <OFMSUI.Row>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                <button type="button" className="btn btn-danger btn-sm" onClick={() => generatePDF("my-table", "Head of Accounts List", "HeadMaster.pdf", 3)} style={{ float: "right", fontSize: "12px" }} >
                  Download PDF
                  <MdOutlinePictureAsPdf />
                </button>
              </OFMSUI.Col>
            </OFMSUI.Row>
            <div style={{ overflow: "auto", height: "600px" }}>
              <Table striped bordered hover id="my-table">
                <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} >
                  <tr className="table_countshead">
                    <th>S No.</th>
                    <th>Head Id</th>
                    <th>Heads Name</th>
                    <th>Payments</th>
                    <th> receipts</th>
                    <th className="text-center">Classification</th>
                    {/* <th>Select</th> */}
                    <th className="text-center">Delete Head</th>
                    <th className="text-center">Edit Head</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData?.map((item, i) => (
                    <tr key={i}>
                      <td style={{ textAlign: "center", width: "50px" }}> {" "} {i + 1} </td>
                      <td style={{ width: "90px" }}>{item.headid}</td>
                      <td style={{ width: "300px" }} onChange={formik.handleChange} > {item.headname} </td>
                      <td className="text-center" style={{ width: "80px" }} onChange={formik.handleChange} > <input type="checkbox" name="payments" checked={item.payments} onChange={formik.handleChange} /> </td>
                      <td className="text-center" style={{ width: "80px" }}> <input type="checkbox" name="receipts" checked={item.receipts} onChange={formik.handleChange} /> </td>
                      <td> <select name={`classification${i}.dropSelect`} defaultValue={item.classification} onChange={formik.handleChange} className={formik.touched.dropselect && formik.errors.dropselect ? "form-control is-invalid" : "form-control"} disabled > {" "} <option>Select</option> {classifyData} </select> </td>
                      <td className="text-center" onClick={() => { deleteAction(item.headid, item.headname, item.payments, item.receipts); }} >

                        <MdPersonRemoveAlt1 style={{ fontSize: "30px", color: "red" }} />
                      </td>
                      <td className="text-center" onClick={() => { editAction(item.headid, item.headname, item.payments, item.receipts, item.classification); }} > <button type="button" className="btn btn-dark btn-sm"> <FaUserEdit style={{ fontSize: "20px", color: "orange", background: "none" }} />
                      </button> </td>

                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <center> <button className="btn btn-primary btn-sm" type="button" onClick={() => { addAction(); }} ><MdPersonAddAlt1 style={{ fontSize: "30px" }} /> Add Head of Accounts </button> </center>
            <Modal fade={false} size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={popup} >
              <Modal.Header> <Modal.Title>Add Head of Accounts</Modal.Title> </Modal.Header>
              <Modal.Body>
                <Form onSubmit={formik.handleSubmit}>
                  <Table striped bordered hover id="my-table">
                    <thead className="fw-bold">
                      <tr className="table_countshead"> <th> Head ID</th> <th>Head Name</th> <th>Payments</th> <th> receipts</th> <th>Classification</th> </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ width: "80px" }}> <Field type="text" name="headid" onChange={formik.handleChange} className={formik.touched.headid && formik.errors.headid ? "form-control is-invalid" : "form-control"} onKeyPress={(e) => NumberValidation(e)} maxLength={10}></Field>{" "} </td>
                        <td style={{ width: "80px" }}> <Field type="text" name="headname" onChange={formik.handleChange} className={formik.touched.headname && formik.errors.headname ? "form-control is-invalid" : "form-control"} maxLength={100} ></Field>{" "} </td>

                        <td style={{ width: "50px" }}> <Field type="checkbox" name="payments" onChange={formik.handleChange} /> </td>
                        <td style={{ width: "50px" }}> <Field type="checkbox" name="receipts" onChange={formik.handleChange} /> </td>

                        <td style={{ width: "100px" }}>
                          {" "}
                          <Field
                            component="select"
                            name="addclassification"
                            className={
                              formik.touched.addclassification &&
                                formik.errors.addclassification
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                          >
                            <option value="">Select</option>
                            {classifyData}
                          </Field>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <OFMSUI.Row>
                    <center>
                      <button
                        type="button"
                        style={{ marginRight: "1rem" }}
                        size="sm"
                        className="btn btn-success"
                        onClick={() => {
                          submitaddAction();
                        }}
                      >
                        Submit
                      </button>

                      <button
                        type="button"
                        style={{ marginRight: "1rem" }}
                        size="sm"
                        onClick={() => {
                          setPopup(false);
                        }}
                        className="btn btn-danger"
                      >
                        Cancel
                      </button>
                    </center>
                  </OFMSUI.Row>
                </Form>
              </Modal.Body>
            </Modal>
            <Modal fade={false} size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={editpopup} >
              <Modal.Header > <Modal.Title >Edit Head of Accounts Details</Modal.Title> </Modal.Header>
              <Modal.Body>
                <Form onSubmit={formik.handleSubmit}>
                  <Table striped bordered hover id="my-table">
                    <thead className="fw-bold">
                      <tr>
                        <th> Head ID</th> <th>Head Name</th> <th>Payments</th> <th> receipts</th> <th>Classification</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ width: "80px" }}>
                          <Field
                            type="text"
                            name="editheadid"
                            onChange={formik.handleChange}
                            className={
                              formik.touched.editheadid &&
                                formik.errors.editheadid
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            disabled
                          ></Field>{" "}
                        </td>
                        <td style={{ width: "80px" }}>
                          <Field
                            type="text"
                            name="editheadname"
                            onChange={formik.handleChange}
                            className={
                              formik.touched.editheadname &&
                                formik.errors.editheadname
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            maxLength={100}
                          ></Field>
                        </td>

                        <td style={{ width: "50px" }}>
                          <Field
                            type="checkbox"
                            name="editpayments"
                            onChange={formik.handleChange}
                          />
                        </td>
                        <td style={{ width: "50px" }}>
                          <Field
                            type="checkbox"
                            name="editreceipts"
                            onChange={formik.handleChange}
                          />
                        </td>

                        <td style={{ width: "100px" }}>
                          {" "}
                          <Field
                            component="select"
                            name="editclassification"
                            className={
                              formik.touched.editclassification &&
                                formik.errors.editclassification
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                          >
                            <option value="">Select</option>
                            {classifyData}
                          </Field>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <OFMSUI.Row>
                    <center>
                      <button
                        type="button"
                        style={{ marginRight: "1rem" }}
                        size="sm"
                        className="btn btn-success"
                        onClick={() => {
                          submitEditAction();
                        }}
                      >
                        Save
                      </button>

                      <button
                        type="button"
                        style={{ marginRight: "1rem" }}
                        size="sm"
                        onClick={() => {
                          seteditPopup(false);
                        }}
                        className="btn btn-danger"
                      >
                        Cancel
                      </button>
                    </center>
                  </OFMSUI.Row>
                </Form>
              </Modal.Body>
            </Modal>
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
}
export default HeadsMaster;
